import { mobileShopApi } from '../mobileShopApi';
import { MasterRow, PagedResponse } from '../../types/master';
import { Bill, Customer } from '../../types/bill';

export const billApi = mobileShopApi.injectEndpoints({
  endpoints: (builder) => ({
    getBillPage: builder.mutation<PagedResponse<MasterRow>, { searchValue: string; page: number; size: number }>({
      query: ({ searchValue, page, size }) => ({
        url: `/bill/search-by-criteria/page=${page}/size=${size}`,
        method: 'POST',
        body: { searchValue },
      }),
    }),

    getBillById: builder.query<Bill, number>({
      query: (id) => `/bill/${id}`,
      providesTags: ['Bill'],
    }),

    saveBill: builder.mutation<Bill, Bill>({
      query: (body) => ({ url: '/bill', method: 'POST', body }),
      invalidatesTags: ['Bill', 'Imei', 'Product', 'Batch'],
    }),

    /** Corrects a bill, keeping its number. Refused by the backend for EMI bills. */
    updateBill: builder.mutation<Bill, Bill>({
      query: (body) => ({ url: '/bill', method: 'PUT', body }),
      invalidatesTags: ['Bill', 'Imei', 'Product', 'Batch'],
    }),

    cancelBill: builder.mutation<Bill, { id: number; reason: string }>({
      query: ({ id, reason }) => ({ url: `/bill/${id}/cancel`, method: 'PUT', body: { reason } }),
      invalidatesTags: ['Bill', 'Imei', 'Product', 'Batch'],
    }),

    /** Type-ahead on the customer box: name or mobile number. */
    searchCustomers: builder.query<Customer[], string>({
      query: (tag) => `/customer/quick-search?tag=${encodeURIComponent(tag)}`,
    }),

    saveCustomer: builder.mutation<Customer, Customer>({
      query: (body) => ({ url: '/customer', method: 'POST', body }),
      invalidatesTags: ['Customer'],
    }),

    getShopSetting: builder.query<MasterRow, void>({
      query: () => '/shop-setting',
      providesTags: ['ShopSetting'],
    }),

    saveShopSetting: builder.mutation<MasterRow, MasterRow>({
      query: (body) => ({ url: '/shop-setting', method: 'PUT', body }),
      invalidatesTags: ['ShopSetting'],
    }),
  }),
});

export const {
  useGetBillPageMutation,
  useLazyGetBillByIdQuery,
  useSaveBillMutation,
  useUpdateBillMutation,
  useCancelBillMutation,
  useLazySearchCustomersQuery,
  useSaveCustomerMutation,
  useGetShopSettingQuery,
  useSaveShopSettingMutation,
} = billApi;
